import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import autoBindMethods from 'class-autobind-decorator';
import { browserHistory } from 'react-router';

import ClientsClass from '../../clients/ClientsClass';
import { AppConstants } from '../../constants';
import { FormModal } from '../../lib/mighty-fields';

import { ILoanAccountFormData, withLeadSourceId } from './leadSource';
import { FIELD_SETS_ACCOUNT_INFO } from './main-details/FieldSets';

const { LOAN_ACCOUNT_DEFAULT_STATUS, LOAN_ACCOUNT_MAIN_TABS, ROUTING } = AppConstants;

interface IProps {
  onClose: () => void;
}

interface IInjected extends IProps {
  Clients: ClientsClass;
}

@inject('Clients')
@autoBindMethods
@observer
class AddLoanAccountModal extends Component<IProps> {
  private get injected () {
    return this.props as IInjected;
  }

  // The owner comes off the session server-side, so the form collects the same fields the Account
  // Info card edits. Errors are left to FormManager, which maps a 400 back onto the fields.
  private async onSave (data: ILoanAccountFormData) {
    const { Clients } = this.injected
      , loanAccount = await Clients.loanAccounts.create(await withLeadSourceId(Clients, data))
      ;

    browserHistory.push(`${ROUTING.loanAccounts}/${loanAccount.id}/${LOAN_ACCOUNT_MAIN_TABS.DETAILS}`);
  }

  public render () {
    return (
      <FormModal
        fieldSets={FIELD_SETS_ACCOUNT_INFO}
        model={{ status: LOAN_ACCOUNT_DEFAULT_STATUS }}
        onClose={this.props.onClose}
        onSave={this.onSave}
        saveText='Add Account'
        title='Add New Account'
      />
    );
  }
}

export default AddLoanAccountModal;
